module.exports = __webpack_public_path__ + "img/2025-05-09d_1.e93d38c4.jpg";